<div
  class="container-rango"
  fxLayout="row wrap">

  <div
    [fxFlex]="colPercent"
    *ngFor="let item of source; let i = index">
    <div fxLayout="column">
      <div class="rango-label-text-center rango-label-number">
        {{(item.number || item.tooltip) | numberThousand}}
      </div>
      <div
        fxLayoutAlign="center center"
        matTooltipPosition="above"
        class="rango-edad rango-color-{{i+1}}">
      </div>
      <div class="rango-label-text-center">{{item.label}}</div>
    </div>
  </div>
</div>
